var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container__nims"},[_c('p',{staticClass:"title"},[_vm._v("환불 정보가 성공적으로 입력 되었습니다.")]),(_vm.isRender)?_c('NimsEmsStep02Template',{attrs:{"refundsInfo":_vm.refundsInfo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }